import React from 'react';
import { AppContext } from "../context/AppContext";

import { translation } from "../localization/translation"


const localize = (WrappedComponent) => {
    class localizeHOC extends React.Component {

        returnLocalizedString = function (key, action, var1, var2) {
            var ret = ""

            if (process.env.REACT_APP_ENVIRO === "development") {
                if (this.context.state.uiLanguage &&
                    translation[this.context.state.uiLanguage] &&
                    translation[this.context.state.uiLanguage].hasOwnProperty(key)) {
                    ret = translation[this.context.state.uiLanguage][key];
                }
                else {
                    // error for when translation does not exist, returns key 
                    ret = "[" + translation['en'][key] + "]";
                }
            } else if (process.env.REACT_APP_ENVIRO === "local") {
                if (this.context.state.uiLanguage &&
                    translation[this.context.state.uiLanguage] &&
                    translation[this.context.state.uiLanguage].hasOwnProperty(key)) {
                    ret = translation[this.context.state.uiLanguage][key];
                }
                else {
                    // error for when translation does not exist, returns key 
                    ret = this.context.state.uiLanguage + " DNE, key: " + key;
                }
            } else {
                if (this.context.state.uiLanguage &&
                    translation[this.context.state.uiLanguage] &&
                    translation[this.context.state.uiLanguage].hasOwnProperty(key)) {
                    ret = translation[this.context.state.uiLanguage][key];
                }
                else if (!translation[this.context.state.uiLanguage].hasOwnProperty(key)) {
                    ret = "N/A, key: " + key;
                }
                else {
                    // error for when translation does not exist, returns key 
                    ret = translation['en'][key];
                }
            }

            if (this.context.state.uiLanguage &&
                translation[this.context.state.uiLanguage] &&
                translation[this.context.state.uiLanguage].hasOwnProperty(action)) {
                ret = ret.replace("%action%", translation[this.context.state.uiLanguage][action]);
            }
            else {
                ret = ret.replace("%action%", translation['en'][action]);
            }
            if (var1 != null) {
                ret = ret.replace('%var1%', var1);
                if (var2 != null) {
                    ret = ret.replace('%var2%', var2);
                }
            }
            ret = ret.replace('%space%', " ");
            return ret;
        }
        //shortened forms of alerts for localization
        errorAlert = function (key, action, var1, var2) {
            this.alert("error", this.returnLocalizedString("m0023"), this.returnLocalizedString(key, action, var1, var2));
        }

        successAlert = function (key, action, var1, var2) {
            this.alert("success", this.returnLocalizedString("m0036"), this.returnLocalizedString(key, action, var1, var2));
        }

        warningAlert = function (key, action, var1, var2) {
            this.alert("warning", this.returnLocalizedString("m0154"), this.returnLocalizedString(key, action, var1, var2));
        }

        infoAlert = function (key, action, var1, var2) {
            this.alert("info", this.returnLocalizedString("m0072"), this.returnLocalizedString(key, action, var1, var2));
        }

        getLanguage = function () {
            return this.context.state.uiLanguage;
        }

        render() {
            return (
                <AppContext.Consumer>
                    {context => (
                        <WrappedComponent 
                        context={context} 
                        returnLocalizedString={this.returnLocalizedString} 
                        errorAlert={this.errorAlert}
                        successAlert = {this.successAlert}
                        warningAlert = {this.warningAlert}
                        infoAlert = {this.infoAlert}
                        getLanguage = {this.getLanguage}
                        uiLanguage = {this.context.state.uiLanguage}
                        {...this.state} 
                        {...this.props} />
                    )}
                </AppContext.Consumer>
            )
        }
    }
    localizeHOC.contextType = AppContext;
    return localizeHOC;
}
export default localize;


// WEBPACK FOOTER //
// ./src/hoc/localize.js